import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

const InputS1Default = ({
                            className,
                            label,
                            readOnly,
                            placeholder,
                            type,
                            size,
                            field,
                            disabled,
                            isRequired,
                            validate,
                            value,
                            prependData,
                            inputClassName,
                            ...props
                        }) => {

    const classes = cx(
        'form-field',
        `form-field--${size}`,
        disabled && `form-field--disabled`,
        value && 'form-field--active',
        className
    );

    return (
        <div className={classes}>
            {label && (
                <label className="form-field__label">
                    {label}
                    {isRequired && <span title={"Обязательный поля"}>*</span>}
                </label>
            )}
            <div className="input-group">
                <input
                    className={`form-field__input ${inputClassName}`}
                    readOnly={readOnly}
                    disabled={disabled}
                    value={value}
                    {...{placeholder, type}}
                    {...props}
                />
                {prependData && prependData}
            </div>
        </div>
    );
};

InputS1Default.propTypes = {
    label: PropTypes.string,
    type: PropTypes.oneOf(["text", "password", "number"]),
    className: PropTypes.string,
    placeholder: PropTypes.string,
    inputClassName: PropTypes.string,
    readOnly: PropTypes.bool,
    size: PropTypes.oneOf(["default", "large", "small"]),
    disabled: PropTypes.bool,
    isRequired: PropTypes.bool,
};

InputS1Default.defaultProps = {
    label: "",
    placeholder: "",
    inputClassName: "",
    type: "text",
    className: null,
    readOnly: false,
    disabled: false,
    isRequired: false,
    size: "default",
};

export default InputS1Default;
